<script setup lang="ts">
import MarkdownIt from 'markdown-it';
const md = new MarkdownIt({
    html: true,
    breaks: true
});

const props = defineProps({
    modelValue: {
        type: String,
        required: true
    }
});

const content = computed(() => {
    return md.render(props.modelValue);
});

</script>

<template>
    <div v-html="content" />
</template>

<style scoped>
</style>
